import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-supply-test',
  templateUrl: './power-supply-test.component.html',
  styleUrls: ['./power-supply-test.component.scss']
})
export class PowerSupplyTestComponent implements OnInit {

  public scannerEnabled: boolean = true;
  public information: string = "11Test QR Scan code";

  constructor() {
  }

  ngOnInit() {
  }

  public scanSuccessHandler($event: any) {
    this.scannerEnabled = false;
    this.information = "Test QR Scan code";
    console.log($event)
    this.information = $event;
  }

  public enableScanner() {
    this.scannerEnabled = !this.scannerEnabled;
    this.information = "Test QR Scan code";
  }

}
